module.exports = "/images/unpaid-icon.svg?a56d008960950a56804240f48c89b340";